export enum Component {
    Accordion = 'accordion',
    Alert = 'alert',
    AlertIcon = 'alertIcon',
    Backdrop = 'backdrop',
    Banner = 'banner',
    BannerPrimaryText = 'bannerPrimaryText',
    BannerSecondaryText = 'bannerSecondaryText',
    BareIconButton = 'bareIconButton',
    Calendar = 'calendar',
    CalendarFooter = 'calendarFooter',
    CalendarSelector = 'calendarSelector',
    Card = 'card',
    CardContent = 'cardContent',
    Dialog = 'dialog',
    Drawer = 'drawer',
    DrawerPill = 'drawerPill',
    Flag = 'flag',
    Icon = 'icon',
    Input = 'input',
    InputClearButton = 'inputClearButton',
    InputIndicativeIconDecision = 'inputIndicativeIconDecision',
    InputAffix = 'inputAffix',
    InputPlaceholder = 'inputPlaceholder',
    LegendCircle = 'legendCircle',
    MessageBubble = 'messageBubble',
    MessageTextarea = 'messageTextarea',
    MewsLogo = 'mewsLogo',
    NavigationList = 'navigationList',
    NestedCard = 'nestedCard',
    NotificationBadge = 'notificationBadge',
    SupplementaryIcon = 'supplementaryIcon',
    SystemWideBanner = 'systemWideBanner',
    Textarea = 'textarea',
    Typography = 'typography',

    /** @deprecated */
    BaseLayout = 'baseLayout',
    /** @deprecated */
    TwoColumnLayoutCell = 'twoColumnLayoutCell',
    /** @deprecated */
    ThreeColumnLayoutCell = 'threeColumnLayoutCell',
    /** @deprecated */
    FourColumnLayoutCell = 'fourColumnLayoutCell',
    /** @deprecated */
    FiveColumnLayoutCell = 'fiveColumnLayoutCell',
    /** @deprecated */
    ContentWithSidebarLayoutSidebarCell = 'contentWithSidebarLayoutSidebarCell',
    /** @deprecated */
    ContentWithSidebarLayoutContentCell = 'contentWithSidebarLayoutContentCell',
    /** @deprecated */
    ContentWithTwoSidebarsLayoutSidebarCell = 'contentWithTwoSidebarsLayoutSidebarCell',
    /** @deprecated */
    ContentWithTwoSidebarsLayoutContentCell = 'contentWithTwoSidebarsLayoutContentCell',
}
